"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledErrorResultsList = exports.StyledLoader = exports.StyledResultsList = exports.StyledAutocompleteWrapper = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_theme_1 = __importStar(require("@travelnest/merlin.theme"));
exports.StyledAutocompleteWrapper = styled_1.default.div `
	/* needed to position results correctly */
	position: relative;
`;
exports.StyledResultsList = styled_1.default.div `
	background: ${merlin_theme_1.default.colours.background.lighter};
	position: absolute;
	top: calc(100% - ${merlin_theme_1.default.layout.spacing.smaller});
	left: 0;
	right: 0;

	/*
	it's important that box-sizing is content-box, otherwise setting the height
	does not account for the border
	*/
	box-sizing: content-box;
	${(props) => props.height ? `height: ${props.height}px;` : ''}

	max-height: calc(100vh - ${({ offset }) => offset + 'px'});
	border: 1px solid ${merlin_theme_1.palette.greyscale.dark};
	box-shadow: 0 1px 5px 0 ${merlin_theme_1.default.colours.shadow.default};
	border-radius: 0 0 ${merlin_theme_1.default.layout.radius.default} ${merlin_theme_1.default.layout.radius.default};

	/* put the y-scroll on the wrapped results container */
	overflow-y: hidden;
	& > * {
		height: 100%;
		overflow-y: scroll;
	}
`;
exports.StyledLoader = (0, styled_1.default)(exports.StyledResultsList) `
	${(props) => props.hasResults ? `border-radius: 0` : ''};
	${(props) => props.hasResults ? `box-shadow: none` : ''};
	${(props) => props.hasResults ? `border-bottom: none` : ''};
`;
exports.StyledErrorResultsList = (0, styled_1.default)(exports.StyledResultsList) `
	color: ${merlin_theme_1.default.colours.error.default};
`;
//# sourceMappingURL=Autocomplete.styled.js.map